export interface VaccineStatusEntity {
    id: number;
    name: string;
    level: number;
    level0_parent_id?: number;
    sort_order: number;
}

export const vaccineStatusHierarchy: VaccineStatusEntity[] = [
    {
        id: 1,
        name: 'Not vaccinated',
        level: 0,
        sort_order: 4,
    },
    {
        id: 2,
        name: 'Seronegative at vaccination',
        level: 1,
        level0_parent_id: 5,
        sort_order: 2,
    },
    {
        id: 3,
        name: 'Seropositive at vaccination',
        level: 1,
        level0_parent_id: 5,
        sort_order: 3,
    },
    {
        id: 4,
        name: 'Any',
        level: 0,
        sort_order: 5,
    },
    {
        id: 5,
        name: 'All vaccinated',
        level: 0,
        sort_order: 1,
    },
];
